<template>
    <div class="settings">
        <!-- Tab content area -->

        <div class="col-sm-12 o-no-padding c-responsive-fixwidth">

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('formatting')}}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('date_format') }}:</h6>
                                        <div class="o-cutsomSelect">
                                            <select v-model="employeeData.date_format" @change="dateSelect()" >
                                                <option v-for="(date,index) in dateFormat" :key="index" :value="date">{{date}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleDate}}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('time_format') }}:</h6>
                                      <!-- <p class="h5-v2">12 Hour Clock</p> -->
                                      <div class="o-cutsomSelect">
                                           <select v-model="employeeData.time_format" @change="timeSelect()">
                                                <option v-for="(time,index) in timeFormat" :key="index" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleTime}}</h6>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="col-sm-6 o-left-padding-only">

                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">Phone format:</h6>
                                        <p class="h5-v2">xxxyyyzzzz</p>
                                    </li>
                                </ul>

                            </div> -->


                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <!-- #1720 P2 — Carpool opt-in + standing pickup location.
                             Opt in to offer transportation, then pick where you'd
                             start from: your verified home pin, or a separate one. -->
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('car_pooling') }}</h2>
                            <p class="ps2">{{ $t('car_pooling_info1') + $t('car_pooling_info2') }}</p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset">
                                    <li>
                                        <label class="o-carpool-optin">
                                            <input type="checkbox" v-model="carpool.opt_in" @change="saveCarpool()" />
                                            <span>I can provide transportation</span>
                                        </label>
                                    </li>
                                </ul>

                                <div v-if="carpool.opt_in" class="o-carpool-pickup">
                                    <h6 class="h6">Pickup location</h6>
                                    <label class="o-carpool-radio">
                                        <input type="radio" value="home" v-model="carpool.pickup_source" @change="saveCarpool()" />
                                        <span>Use my address on file<small v-if="carpool.home && carpool.home.address"> — {{ carpool.home.address }}</small></span>
                                    </label>
                                    <p v-if="carpool.pickup_source === 'home' && carpool.home && !carpool.home.verified" class="o-carpool-warn">
                                        Your address on file isn't pin-verified yet — confirm it at your next address step, or choose a different pickup address below.
                                    </p>
                                    <label class="o-carpool-radio">
                                        <input type="radio" value="custom" v-model="carpool.pickup_source" />
                                        <span>Use a different pickup address</span>
                                    </label>

                                    <div v-if="carpool.pickup_source === 'custom'" class="o-carpool-custom">
                                        <input type="text" class="form-control" v-model.trim="carpool.pickup_address" placeholder="Pickup address (street, city, state)" />
                                        <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue o-carpool-pinbtn" :disabled="!carpool.pickup_address" @click="openCarpoolPin()">
                                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                                            {{ carpool.pickup_verified ? "Pin confirmed — adjust" : "Set pin on map" }}
                                        </button>
                                        <p v-if="carpool.pickup_lat" class="o-carpool-coords">
                                            {{ Number(carpool.pickup_lat).toFixed(6) }}, {{ Number(carpool.pickup_lng).toFixed(6) }}
                                            <span v-if="!carpool.pickup_verified"> (unconfirmed)</span>
                                        </p>
                                    </div>

                                    <button type="button" class="btn c-solid-btn c-solid-btn--green o-carpool-save" :disabled="carpoolSaving" @click="saveCarpool()">
                                        <i class="fa fa-save" aria-hidden="true"></i> Save carpool settings
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- #1720 — visual break between the Carpool card and Calendar Sync. -->
                        <div class="o-carpool-sep"></div>

                        <!-- #1720 P2 — pickup pin confirm (reuses the #1715 VenuePinMap). -->
                        <modal name="carpool-pin" :width="560" height="auto" :adaptive="true" @closed="carpoolPinShow = false">
                            <div class="o-carpool-pin-modal">
                                <h5 class="c-common-heading">Is this pickup location correct?</h5>
                                <VenuePinMap
                                    v-if="carpoolPinShow"
                                    :address="carpool.pickup_address"
                                    :lat="carpool.pickup_lat ? Number(carpool.pickup_lat) : null"
                                    :lng="carpool.pickup_lng ? Number(carpool.pickup_lng) : null"
                                    :source="carpool.pickup_coords_source"
                                    :draggable="carpoolPinDraggable"
                                    :zoom="17"
                                    @update:coords="onCarpoolCoords" />
                                <div class="o-carpool-pin-actions">
                                    <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue" @click="closeCarpoolPin()">Cancel</button>
                                    <template v-if="!carpoolPinDraggable">
                                        <button type="button" class="btn c-solid-btn c-solid-btn--green" @click="confirmCarpoolPin()">That's correct</button>
                                        <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue" @click="carpoolPinDraggable = true">Move pin</button>
                                    </template>
                                    <button v-else type="button" class="btn c-solid-btn c-solid-btn--green" @click="confirmCarpoolPin()">Save this location</button>
                                </div>
                            </div>
                        </modal>

                        <!-- #1548/#1644 Calendar Sync (replaces the retired Nylas tab, #1516) —
                             reorganized into 4 titled protocol boxes, each with a "what to expect"
                             line + a badge, in order: ICS base → Google → Apple CalDAV → Apple ICS/QR. -->
                        <div class="col-md-12">
                            <h2 class="h2 o-cs-header">Calendar Sync</h2>
                            <p class="ps2 o-cs-subtitle">
                                Choose how your confirmed calls reach your calendar — you can use more than one.
                                Each option below tells you what to expect.
                            </p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">

                                <div v-if="calFeedLoading" class="o-cal-feed-loading">
                                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading your calendar link…
                                </div>
                                <div v-else>
                                    <!-- #1644 BOX 1 · Your Calendar Link (ICS base & backup). Owns the
                                         other-calendars/Outlook/Yahoo use-case + the universal link + Reset. -->
                                    <div class="o-cs-card">
                                        <div class="o-cs-row1">
                                            <span class="o-cs-num">1</span>
                                            <h3 class="o-cs-title">Your Calendar Link</h3>
                                            <span class="o-cs-badge o-cs-badge--base">Base &amp; backup · ICS</span>
                                        </div>
                                        <p class="o-cs-exp">
                                            Your <b>universal calendar link</b> — this is how you add <b>other calendars</b>
                                            (Outlook, Yahoo, Google‑by‑URL), and it's the <b>backup source</b> behind every
                                            option below. Pull‑based: your app refreshes it every <b>~15 min–1 hour</b>.
                                        </p>
                                        <div class="o-cs-ctrls">
                                            <div class="o-cal-feed-row">
                                                <input type="text" class="form-control o-cal-feed-url" :value="calFeedUrl"
                                                    readonly @focus="$event.target.select()" aria-label="Calendar subscription link" />
                                                <el-button type="primary" size="small" :disabled="!calFeedUrl" @click="copyFeedUrl">
                                                    <i class="fa fa-clipboard" aria-hidden="true"></i> Copy link
                                                </el-button>
                                            </div>
                                            <div class="o-cs-btns">
                                                <el-button type="text" size="small" class="o-cs-danger" :loading="calRotating"
                                                    :disabled="!calendarEstablished" @click="rotateFeed">
                                                    <i class="fa fa-refresh" aria-hidden="true"></i> Reset calendar link
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- #1644 BOX 2 · Google Calendar (most dependable, near-instant push). -->
                                    <div class="o-cs-card">
                                        <div class="o-cs-row1">
                                            <span class="o-cs-num">2</span>
                                            <h3 class="o-cs-title">Google Calendar</h3>
                                            <span class="o-cs-badge o-cs-badge--good"><i class="fa fa-check" aria-hidden="true"></i> Most dependable</span>
                                        </div>
                                        <p class="o-cs-exp">
                                            The <b>most reliable, near‑instant</b> option. Pushes your confirmed calls
                                            straight into Google Calendar — usually <b>within a minute</b>.
                                        </p>
                                        <div class="o-cs-ctrls">
                                            <template v-if="!googleConnected">
                                                <div class="o-cs-btns">
                                                    <el-button type="primary" size="small" :loading="googleBusy" @click="connectGoogle">
                                                        <i class="fa fa-google" aria-hidden="true"></i> Connect Google Calendar
                                                    </el-button>
                                                </div>
                                                <p class="o-cs-note">You'll pick your Google account to connect. Sync buttons appear once connected.</p>
                                            </template>
                                            <template v-else>
                                                <p class="o-cs-connected">
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                    Connected<span v-if="googleEmail"> ({{ googleEmail }})</span>.
                                                </p>
                                                <div class="o-cs-btns">
                                                    <el-button size="small" :loading="calTesting" :disabled="!calendarEstablished" @click="sendTestEvent">
                                                        <i class="fa fa-paper-plane" aria-hidden="true"></i> Send test event
                                                    </el-button>
                                                    <el-button type="primary" size="small" :loading="googleSyncing==='full'" :disabled="!!googleSyncing" @click="syncGoogle()">
                                                        <i class="fa fa-refresh" aria-hidden="true"></i> Sync
                                                    </el-button>
                                                    <el-button size="small" :loading="googleSyncing==='next_90'" :disabled="!!googleSyncing" @click="syncGoogle('next_90')">
                                                        <i class="fa fa-arrow-right" aria-hidden="true"></i> Next 90
                                                    </el-button>
                                                    <el-button size="small" :loading="googleSyncing==='last_90'" :disabled="!!googleSyncing" @click="syncGoogle('last_90')">
                                                        <i class="fa fa-arrow-left" aria-hidden="true"></i> Last 90
                                                    </el-button>
                                                    <el-button type="text" size="small" class="o-cs-danger" :loading="googleBusy" :disabled="!!googleSyncing" @click="disconnectGoogle">
                                                        <i class="fa fa-unlink" aria-hidden="true"></i> Disconnect
                                                    </el-button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <!-- #1644 BOX 3 · Apple Calendar Two-way (CalDAV) — caution/amber: flaky. -->
                                    <div class="o-cs-card o-cs-card--caution">
                                        <div class="o-cs-row1">
                                            <span class="o-cs-num">3</span>
                                            <h3 class="o-cs-title">Apple Calendar — Two‑way</h3>
                                            <span class="o-cs-badge o-cs-badge--beta">Beta · flaky · CalDAV</span>
                                        </div>
                                        <p class="o-cs-exp">
                                            <b>Two‑way sync</b> into your iCloud calendar — <b>faster than the ICS subscribe
                                            below</b>, but <b>currently flaky</b>: delivery isn't dependable yet. Needs a
                                            one‑time Apple <b>app‑specific password</b>.
                                        </p>
                                        <div class="o-cs-ctrls">
                                            <template v-if="!appleConnected">
                                                <div class="o-cs-warnbox">
                                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                                    <span>
                                                        Apple requires an <strong>app‑specific password</strong> (not your Apple ID password).
                                                        <a href="https://appleid.apple.com/account/manage" target="_blank" rel="noopener noreferrer">Create app‑specific password ↗</a>,
                                                        then paste it here — takes ~30 seconds.
                                                    </span>
                                                </div>
                                                <div class="o-cs-btns">
                                                    <el-button size="small" @click="pasteApplePassword" title="Paste from clipboard">
                                                        <i class="fa fa-clipboard" aria-hidden="true"></i> Paste password
                                                    </el-button>
                                                </div>
                                                <el-input v-model="appleId" size="small" placeholder="Apple ID (email)" style="margin:8px 0;" />
                                                <div class="o-cs-field-row">
                                                    <el-input v-model="applePassword" size="small" type="password"
                                                        placeholder="App‑specific password (xxxx-xxxx-xxxx-xxxx)" show-password />
                                                    <el-button type="primary" size="small" :loading="appleBusy"
                                                        :disabled="!appleId || !applePassword" @click="connectApple">
                                                        <i class="fa fa-apple" aria-hidden="true"></i> Connect
                                                    </el-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="o-cs-connected">
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                    Connected<span v-if="appleAppleId"> ({{ appleAppleId }})</span>.
                                                </p>
                                                <div class="o-cs-btns">
                                                    <el-button size="small" :loading="calTesting" :disabled="!calendarEstablished" @click="sendTestEvent">
                                                        <i class="fa fa-paper-plane" aria-hidden="true"></i> Send test event
                                                    </el-button>
                                                    <el-button type="primary" size="small" :loading="appleSyncing==='full'" :disabled="!!appleSyncing" @click="syncApple()">
                                                        <i class="fa fa-refresh" aria-hidden="true"></i> Sync
                                                    </el-button>
                                                    <el-button size="small" :loading="appleSyncing==='next_90'" :disabled="!!appleSyncing" @click="syncApple('next_90')">
                                                        <i class="fa fa-arrow-right" aria-hidden="true"></i> Next 90
                                                    </el-button>
                                                    <el-button size="small" :loading="appleSyncing==='last_90'" :disabled="!!appleSyncing" @click="syncApple('last_90')">
                                                        <i class="fa fa-arrow-left" aria-hidden="true"></i> Last 90
                                                    </el-button>
                                                    <el-button type="text" size="small" class="o-cs-danger" :loading="appleBusy" :disabled="!!appleSyncing" @click="disconnectApple">
                                                        <i class="fa fa-unlink" aria-hidden="true"></i> Disconnect
                                                    </el-button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <!-- #1644 BOX 4 · Apple Calendar ICS via QR (read-only, Apple-focused). -->
                                    <div class="o-cs-card">
                                        <div class="o-cs-row1">
                                            <span class="o-cs-num">4</span>
                                            <h3 class="o-cs-title">Apple Calendar — ICS via QR Code</h3>
                                            <span class="o-cs-badge o-cs-badge--ro">Read‑only · ICS</span>
                                        </div>
                                        <p class="o-cs-exp">
                                            <b>Scan the QR with your iPhone</b> to subscribe. Read‑only and pull‑based —
                                            Apple refreshes in minutes. Built on your calendar link (Box 1).
                                        </p>
                                        <div class="o-cs-ctrls">
                                            <div class="o-cs-qrline">
                                                <!-- QR renders only on non-Apple devices (qrSvg is generated there);
                                                     on an Apple device the one-tap "Add to Apple Calendar" is used. -->
                                                <div v-if="qrSvg" class="o-cal-qr" v-html="qrSvg" aria-label="Apple Calendar subscribe QR code"></div>
                                                <div class="o-cs-qr-actions">
                                                    <a class="el-button el-button--default el-button--small o-cal-link-btn"
                                                        :class="{ 'is-disabled': !calFeedUrl }" :href="calFeedUrl ? webcalUrl : 'javascript:void(0)'">
                                                        <i class="fa fa-apple" aria-hidden="true"></i> Add to Apple Calendar
                                                    </a>
                                                    <el-button type="text" size="small" :disabled="!calFeedUrl" @click="copyFeedUrl">
                                                        <i class="fa fa-clipboard" aria-hidden="true"></i> Copy link
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('job_notifications') || 'Job Notifications' }}:</h2>
                            <p class="ps2">{{ $t('select_notify_channel') }} </p>
                            <p v-if="clientData && clientData.suppress_sms" style="color: #e6a23c; font-size: 12px; margin-top: 4px;"><i class="fa fa-exclamation-triangle"></i> SMS notifications disabled at client level</p>
                        </div>
                        <div v-if="!clientData" class="col-sm-12 text-center" style="padding: 15px;"><i class="fa fa-spinner fa-spin"></i></div>
                        <div v-else class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="app" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('app')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyApp"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToApp()"
                                                >
                                            </el-switch>
                                                {{ $t('push_notifications') || 'Push Notifications' }}
                                                <span v-if="notifyApp && browserPushState === 'denied'" style="color:#F56C6C; font-size:12px;">(Blocked — enable in browser settings)</span>
                                        </div>
                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                APP
                                                <input type="checkbox" name="o4" v-model="employeeData.app_notification" @change="changeAppNotification()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="email" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('email_primary') }}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyEmail"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToEmail()"
                                                >
                                            </el-switch>
                                                {{$t('email_primary') }}
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                Email(primary)
                                                <input type="checkbox" name="o4" v-model="employeeData.email_notification" @change="emailNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                    <li v-if="!isCallstewardUK()">
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="sms" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('sms_cell')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifySms"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                :disabled="!!(clientData && clientData.suppress_sms)"
                                                @change="changeNotifyToSms()"
                                                >
                                            </el-switch>
                                                    {{$t('sms_cell') }}
                                                    <span v-if="clientData && clientData.suppress_sms" style="color: #999; font-size: 11px;">(disabled by admin)</span>
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                SMS(cell)
                                                <input type="checkbox" name="o4" v-model="employeeData.sms_notification" @change="smsNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-12">
                                <h2 class="h2" v-if="isCallstewardUK()">Stop Email:</h2>
                                <h2 class="h2" v-else> {{ $t('stop_email_sms') }}: </h2>
                                <!-- <p class="ps2">Do you want to stop receive email and sms?.</p>
                                <el-switch
                                    v-model="notifyLock"
                                    @change="notifyStartStop()"
                                    style="display: block"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6">
                                </el-switch> -->
                            </div>
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">


                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="false" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('receive') }}
                                            </label>
                                        </div>

                                    </li>
                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="true" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('stop') }}
                                            </label>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-12">

                        </div>

                        <!-- <div class="col-md-12" v-if="getLogsAccess()">
                            <div>
                                <h2 class="h2">{{ $t('navigation_history') }}: </h2>
                                <p class="ps2">{{ $t('navigation_notification_note') }} </p>
                            </div>
                            <div class="o-employe-view">
                                <a href="javascript: void(0)" @click="notifyHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('click_to_view') }} </a>
                            </div>
                        </div> -->

                                <!-- <p class="ps2">{{ $t('navigation_notification_note') }} </p> -->
                        <!-- <div class="col-md-12" v-if="mailing_list_visibility_flag">
                            <div>
                                <h2 class="h2">Announcements from other IATSE Locals: </h2>
                            </div>
                            <div class="o-employe-view">
                                <el-switch
                                    v-model="mailing_action"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value = 1
                                    :inactive-value = 0
                                    @change="changeMailingAction()"
                                    >
                                </el-switch>
                                An Email List
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('login_options')}}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="twoFactorAuth" :checked="two_factor_auth" @click="changeSignInOptions2fa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('2fa_authentication') }}
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="fingerPrintAuth" :checked="finger_print_auth" @click="changeSignInOptionsFpa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                {{ $t('finger_print_authentication') }}
                                                {{ $t('google_ios_authorization') }}
                                            </label>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-sm-3 o-no-padding">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">Notifications:</h2>
                            <p class="ps2">Your .ics calendar file is located at:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="ps2">If shifts are imported incorrectly, try the UTC calendar:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>

        <!-- /Tab content area -->

        <!-- Push Notification Pre-Prompt Dialog -->
        <el-dialog
            :visible.sync="showPushPrompt"
            width="420px"
            :close-on-click-modal="false"
            custom-class="push-prompt-dialog"
            center>
            <div style="text-align:center; padding: 10px 0;">
                <i class="fa fa-bell" style="font-size: 48px; color: #13ce66; margin-bottom: 16px; display:block;"></i>
                <h3 style="margin-bottom: 12px; font-size: 18px;">Enable Push Notifications</h3>
                <p style="color: #606266; font-size: 14px; line-height: 1.6; margin-bottom: 8px;">
                    Get real-time job alerts and updates delivered directly to this browser — even when the tab is in the background.
                </p>
                <p style="color: #909399; font-size: 12px;">
                    You can disable this anytime from your settings.
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="declinePushPrompt" size="medium">Not Now</el-button>
                <el-button type="success" @click="acceptPushPrompt" size="medium">Enable Notifications</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
    // import { global } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    // #2066 — Stripe is removed from cs3. The `loadStripe()` call that used to sit in this
    // file's init path injected https://js.stripe.com/v3 and beaconed r./m./q.stripe.com on
    // every page load, with no Stripe feature left to serve.
    import { mapGetters } from 'vuex';
    import QRCode from 'qrcode'; // #1572 client-side Apple-subscribe QR (no CDN, CSP-safe)
    import VenuePinMap from '../venue/VenuePinMap.vue'; // #1720 P2 — reuse the #1715 pin editor
    // import { bus } from '../../main';
    import { requestNotificationPermission, getNotificationPermissionState } from '../../utils/firebase-messaging';

    export default {
        components: {
            // StripeCheckout
            VenuePinMap, // #1720 P2 — pickup pin editor
        },
        data() {
            return {
                // #1720 P2 — carpool profile (opt-in + standing pickup location).
                carpool: {
                    opt_in: false,
                    pickup_source: 'home',
                    pickup_address: null,
                    pickup_lat: null,
                    pickup_lng: null,
                    pickup_verified: false,
                    pickup_coords_source: null,
                    home: null,
                },
                carpoolSaving: false,
                carpoolPinShow: false,
                carpoolPinDraggable: false,
                stripe: null,
                stripe_customer_id: '',
                is_nylas_subscription_active: false,
                nylas_subscription: null,
                stripe_subscription: null,
                employeeEmail: '',
                dataAvailable: false,
                lineItems:
                {
                    price: 'price_1KdwUrJTPH63iEDVOSzQU9ui', // The id of the recurring price you created in your Stripe dashboard
                    quantity: 1
                },
                successURL: window.location.href.split('#')[0]+"#/stripe-success",
                cancelURL: window.location.href,
                loading: false,
                able_to_access_logs: null,
                notifyApp: false,
                notifyEmail: false,
                notifySms: false,
                browserPushState: getNotificationPermissionState(),
                showPushPrompt: false,
                two_factor_auth: false,
                finger_print_auth: false,
                pickedNotify: 'sms',
                notifyLock:true,
                ics_link:'',
                exampleDate: moment(Date.now()).format("DD MMMM YYYY"),
                dateFormat: [
                    "MM-DD-YY",
                    "MM/DD/YYYY",
                    "MMM DD YYYY",
                    "MMMM DD YYYY",
                    "DD-MM-YY",
                    "DD-MM-YYYY",
                    "DD MMM YYYY",
                    "DD MMMM YYYY",
                    "YYYY-MM-DD",
                    "YYYY MMM DD",
                    "YYYY MMMM DD",
                ],
                exampleTime: moment(Date.now()).format("hh:mm a"),
                timeFormat: [
                    "hh:mm a",
                    "HH:mm",
                ],
                selectDate: '',
                selectTime: '',
                employeeData: [],
                mailing_action: false,
                clientData: null,
                mailing_list_visibility_flag: false,
                // #1548 Calendar Subscription
                calFeedUrl: '',
                calFeedLoading: false,
                calRotating: false,
                calTesting: false,
                // #1519 Google Calendar direct push (OAuth)
                googleConnected: false,
                googleEmail: '',
                googleBusy: false,
                // #1616/#1644 per-channel windowed push in-flight markers
                // ('' | 'full' | 'next_90' | 'last_90') — each channel box drives only
                // its own channel (Google box → Google, Apple box → Apple CalDAV).
                googleSyncing: '',
                appleSyncing: '',
                // #1519 Apple Calendar two-way (CalDAV) — opt-in, alongside ICS
                appleConnected: false,
                appleAppleId: '',
                appleBusy: false,
                appleFormOpen: false,
                appleId: '',
                applePassword: '',
                // #1572 Apple subscribe QR (desktop-primary; scan with iPhone)
                qrSvg: ''
            }
        },
        props: {
            // userProfile: {
            //     type: Object,
            //     required: true
            // }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                currentEmployeeID: 'currentEmployeeID',
                // getNotificationType: 'getNotificationType',
                userID: 'userID',
                getNylasUserEmail: 'getNylasUserEmail'
            }),
            // #1548 — webcal:// deep-link for Apple/Outlook one-tap subscribe.
            webcalUrl() {
                return this.calFeedUrl ? this.calFeedUrl.replace(/^https?:\/\//i, 'webcal://') : '';
            },
            // #1519 — is ANY calendar channel established? Google connected OR ICS feed
            // minted OR Apple CalDAV connected. Post-subscribe controls (Send test /
            // Reset / Sync trio) render off this so a CalDAV-only connection counts as
            // established (the web companion to the mobile v105 gating fix).
            calendarEstablished() {
                return this.googleConnected || this.appleConnected || !!this.calFeedUrl;
            }
        },
        watch: {
            // #1572 fix — the Apple QR must ALWAYS encode the LIVE feed_url. Reset/
            // rotate/reconnect changes calFeedUrl (new token); regenerate the QR from
            // the current webcalUrl so it never keeps a stale/orphaned token (which
            // would subscribe a scanning phone to a dead feed). The URL text is
            // already reactive via :value="calFeedUrl"; this keeps the QR in lockstep.
            calFeedUrl() {
                this.syncAppleQr();
            }
        },
        methods: {
            // ── #1548 Calendar Subscription ──────────────────────────────
            calFeedHeaders() {
                return {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                };
            },
            // ── #1720 P2 Carpool ─────────────────────────────────────────
            async loadCarpool() {
                try {
                    const res = await service.get('carpool', this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.carpool.opt_in = !!r.opt_in;
                    this.carpool.pickup_source = r.pickup_source || 'home';
                    this.carpool.pickup_address = r.pickup_address || null;
                    this.carpool.pickup_lat = r.pickup_lat != null ? r.pickup_lat : null;
                    this.carpool.pickup_lng = r.pickup_lng != null ? r.pickup_lng : null;
                    this.carpool.pickup_verified = !!r.pickup_verified;
                    // Backend stores only verified-ness for the pickup; derive a source
                    // so re-opening the map seeds the existing pin correctly.
                    this.carpool.pickup_coords_source = r.pickup_verified
                        ? 'manual' : (r.pickup_lat != null ? 'geocoded' : null);
                    this.carpool.home = r.home || null;
                } catch (e) { console.log('loadCarpool error:', e); }
            },
            async saveCarpool() {
                this.carpoolSaving = true;
                try {
                    const payload = {
                        opt_in: this.carpool.opt_in,
                        pickup_source: this.carpool.pickup_source,
                        pickup_address: this.carpool.pickup_address,
                        lat: this.carpool.pickup_lat,
                        lng: this.carpool.pickup_lng,
                        coords_source: this.carpool.pickup_coords_source,
                        coords_verified: this.carpool.pickup_verified,
                    };
                    const res = await service.post('carpool', payload, this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.carpool.pickup_source = r.pickup_source || this.carpool.pickup_source;
                    this.carpool.pickup_address = r.pickup_address || null;
                    this.carpool.pickup_lat = r.pickup_lat != null ? r.pickup_lat : null;
                    this.carpool.pickup_lng = r.pickup_lng != null ? r.pickup_lng : null;
                    this.carpool.pickup_verified = !!r.pickup_verified;
                    this.carpool.home = r.home || this.carpool.home;
                    this.$notify({ title: 'Saved', message: 'Carpool settings updated.', type: 'success' });
                } catch (e) {
                    console.log('saveCarpool error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not save carpool settings.' });
                } finally { this.carpoolSaving = false; }
            },
            openCarpoolPin() {
                this.carpoolPinDraggable = false;
                this.carpoolPinShow = true;
                this.$modal.show('carpool-pin');
            },
            closeCarpoolPin() {
                this.carpoolPinShow = false;
                this.carpoolPinDraggable = false;
                this.$modal.hide('carpool-pin');
            },
            onCarpoolCoords({ lat, lng, source }) {
                this.carpool.pickup_lat = lat;
                this.carpool.pickup_lng = lng;
                this.carpool.pickup_coords_source = source;
            },
            // "That's correct" / "Save this location" — human-confirmed pin.
            confirmCarpoolPin() {
                this.carpool.pickup_verified = true;
                this.carpoolPinShow = false;
                this.carpoolPinDraggable = false;
                this.$modal.hide('carpool-pin');
            },
            // ── #1519 Google Calendar direct push (OAuth) ────────────────
            // NON-minting status read; sets the connect-vs-disconnect button state.
            async loadGoogleStatus() {
                try {
                    const res = await service.getUrl('/api/v3/calendar-google/status', this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.googleConnected = !!r.connected;
                    this.googleEmail = r.email || '';
                } catch (e) { console.log('loadGoogleStatus error:', e); }
            },
            // Full redirect into Google's account picker (backend returns auth_url).
            async connectGoogle() {
                this.googleBusy = true;
                try {
                    const returnUrl = window.location.href;
                    const res = await service.getUrl('/api/v3/calendar-google/connect?return_url=' + encodeURIComponent(returnUrl), this.calFeedHeaders());
                    const url = res && res.data && res.data.result && res.data.result.auth_url;
                    if (url) { window.location.href = url; }
                    else { this.$notify.error({ title: 'Error', message: 'Could not start Google connect.' }); }
                } catch (e) {
                    console.log('connectGoogle error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not start Google connect.' });
                } finally { this.googleBusy = false; }
            },
            async disconnectGoogle() {
                this.googleBusy = true;
                try {
                    await service.postUrl('/api/v3/calendar-google/disconnect', {}, this.calFeedHeaders());
                    this.googleConnected = false;
                    this.googleEmail = '';
                    this.$notify({ title: 'Disconnected', message: 'Google Calendar was disconnected.', type: 'success' });
                } catch (e) {
                    console.log('disconnectGoogle error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not disconnect Google Calendar.' });
                } finally { this.googleBusy = false; }
            },
            // #1644 — windowed push scoped to ONE channel (each channel box drives only
            // its own channel; the shared fan-out was split when the UI became per-box).
            // window: undefined (full reconcile) | 'next_90' | 'last_90' (additive).
            async syncGoogle(window) {
                this.googleSyncing = window || 'full';
                try {
                    const r = await this.pushOne('/api/v3/calendar-google/sync', window ? { window: window } : {}, 'Google');
                    this.notifySync(r.ok, window, 'Google');
                } finally { this.googleSyncing = ''; }
            },
            async syncApple(window) {
                this.appleSyncing = window || 'full';
                try {
                    const r = await this.pushOne('/api/v3/calendar-apple/sync', window ? { window: window } : {}, 'Apple');
                    this.notifySync(r.ok, window, 'Apple');
                } finally { this.appleSyncing = ''; }
            },
            notifySync(ok, window, channel) {
                const label = window === 'next_90' ? 'next 90 days'
                    : (window === 'last_90' ? 'last 90 days' : 'full schedule');
                if (ok) {
                    this.$notify({ title: 'Synced', message: 'Pushed your ' + label + ' to ' + channel + ' Calendar.', type: 'success' });
                } else {
                    this.$notify.error({ title: 'Sync failed', message: 'Could not sync to ' + channel + ' Calendar. Please try again shortly.' });
                }
            },
            // POST one channel's sync; resolve {channel, ok} (never throws).
            async pushOne(url, body, channel) {
                try {
                    const res = await service.postUrl(url, body, this.calFeedHeaders());
                    return { channel: channel, ok: !!(res && res.data && res.data.status_code === 1) };
                } catch (e) {
                    console.log('pushOne ' + channel + ' error:', e);
                    return { channel: channel, ok: false };
                }
            },
            // ── #1519 Apple Calendar two-way (CalDAV) — opt-in, alongside ICS ──
            // NON-minting status read; sets the connect-vs-disconnect button state.
            async loadAppleStatus() {
                try {
                    const res = await service.getUrl('/api/v3/calendar-apple/status', this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.appleConnected = !!r.connected;
                    this.appleAppleId = r.apple_id || '';
                } catch (e) { console.log('loadAppleStatus error:', e); }
            },
            // Paste-from-clipboard shortcut for the app-specific password (users copy
            // it straight off appleid.apple.com). navigator.clipboard needs a secure
            // context + user gesture (this @click provides it); degrade gracefully.
            async pasteApplePassword() {
                try {
                    if (navigator.clipboard && navigator.clipboard.readText) {
                        const txt = await navigator.clipboard.readText();
                        if (txt) { this.applePassword = txt.trim(); }
                    } else {
                        this.$notify({ title: 'Paste manually', message: 'Clipboard access is unavailable — paste the password into the field.', type: 'info' });
                    }
                } catch (e) {
                    console.log('pasteApplePassword error:', e);
                    this.$notify({ title: 'Paste manually', message: 'Could not read the clipboard — paste the password into the field.', type: 'info' });
                }
            },
            cancelAppleForm() {
                this.appleFormOpen = false;
                this.appleId = '';
                this.applePassword = '';
            },
            async connectApple() {
                if (!this.appleId || !this.applePassword) { return; }
                this.appleBusy = true;
                try {
                    const res = await service.postUrl('/api/v3/calendar-apple/connect', {
                        apple_id: this.appleId,
                        app_password: this.applePassword
                    }, this.calFeedHeaders());
                    const body = (res && res.data) || {};
                    if (body.status_code === 1 && body.result && body.result.connected) {
                        this.appleConnected = true;
                        this.appleAppleId = body.result.apple_id || this.appleId;
                        this.cancelAppleForm();
                        this.$notify({ title: 'Connected', message: 'Apple Calendar was connected.', type: 'success' });
                    } else {
                        this.$notify.error({ title: 'Could not connect', message: body.message || 'Check your Apple ID and app-specific password.' });
                    }
                } catch (e) {
                    console.log('connectApple error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not connect Apple Calendar.' });
                } finally { this.appleBusy = false; }
            },
            async disconnectApple() {
                this.appleBusy = true;
                try {
                    await service.postUrl('/api/v3/calendar-apple/disconnect', {}, this.calFeedHeaders());
                    this.appleConnected = false;
                    this.appleAppleId = '';
                    this.$notify({ title: 'Disconnected', message: 'Apple Calendar was disconnected.', type: 'success' });
                } catch (e) {
                    console.log('disconnectApple error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not disconnect Apple Calendar.' });
                } finally { this.appleBusy = false; }
            },
            async loadCalendarFeed() {
                this.calFeedLoading = true;
                try {
                    const res = await service.getUrl('/api/v3/calendar-feed', this.calFeedHeaders());
                    // Assigning calFeedUrl triggers the watcher → the Apple QR
                    // (re)renders from the LIVE feed_url. #1572
                    this.calFeedUrl = (res && res.data && res.data.result && res.data.result.feed_url)
                        ? res.data.result.feed_url : '';
                } catch (err) {
                    console.log('loadCalendarFeed error:', err);
                    this.$notify.error({ title: 'Error', message: 'Could not load your calendar subscription link.' });
                } finally {
                    this.calFeedLoading = false;
                }
            },
            // #1572 — keep the Apple QR in lockstep with the current feed_url:
            // regenerate on a non-Apple device, clear it otherwise (Apple / no feed).
            // Called by the calFeedUrl watcher so Reset/rotate/reconnect never leaves
            // a stale QR encoding a dead token.
            syncAppleQr() {
                if (this.calFeedUrl && !this.isApplePlatform()) {
                    this.renderAppleQr();
                } else {
                    this.qrSvg = '';
                }
            },
            // #1572 — Apple platform probe: macOS / iOS / iPadOS (reports as
            // Macintosh). Windows/Android are explicitly non-Apple (no webcal handler).
            isApplePlatform() {
                const ua = navigator.userAgent || '';
                const plat = navigator.platform || '';
                if (/Windows|Android/i.test(ua)) return false;
                return /iPhone|iPad|iPod|Macintosh|Mac OS X/i.test(ua) || /iPhone|iPad|iPod|Mac/i.test(plat);
            },
            // #1572 — build the QR locally (SVG string; the private feed token
            // never leaves the browser, no CDN → CSP-safe). Encodes the webcal://
            // feed URL so an iPhone camera opens the Apple Calendar subscribe.
            async renderAppleQr() {
                try {
                    this.qrSvg = await QRCode.toString(this.webcalUrl, {
                        type: 'svg', margin: 1, width: 220, errorCorrectionLevel: 'M'
                    });
                } catch (e) {
                    console.log('Apple QR generation failed:', e);
                    this.qrSvg = ''; // the webcal link + copy still work if the QR can't render
                }
            },
            copyFeedUrl() {
                const url = this.calFeedUrl;
                if (!url) return;
                try {
                    navigator.clipboard.writeText(url);
                } catch (e) {
                    const el = document.createElement('textarea');
                    el.value = url;
                    document.body.appendChild(el);
                    el.select();
                    try { document.execCommand('copy'); } catch (ee) { /* ignore */ }
                    document.body.removeChild(el);
                }
                this.$notify({ title: 'Copied', message: 'Calendar link copied to your clipboard.', type: 'success' });
            },
            rotateFeed() {
                // #1519 — Reset revokes ALL of a user's calendar access: the ICS link is
                // re-issued (old one dies) AND, if Apple two-way (CalDAV) is connected,
                // it is disconnected too (the stored app-specific password is revoked).
                const msg = this.appleConnected
                    ? 'Reset your calendar access? The current ICS link stops working immediately, and your Apple two-way (CalDAV) connection will be disconnected. You can reconnect Apple afterwards.'
                    : 'Reset your calendar link? The current link will stop working immediately and any calendars subscribed to it will need the new link.';
                this.$confirm(
                    msg,
                    'Reset calendar access',
                    { confirmButtonText: 'Reset', cancelButtonText: 'Cancel', type: 'warning' }
                ).then(async () => {
                    this.calRotating = true;
                    try {
                        const res = await service.postUrl('/api/v3/calendar-feed/rotate', {}, this.calFeedHeaders());
                        this.calFeedUrl = (res && res.data && res.data.result && res.data.result.feed_url)
                            ? res.data.result.feed_url : '';
                        // Also disconnect Apple CalDAV if connected (revoke app password + clean collection).
                        if (this.appleConnected) {
                            try {
                                await service.postUrl('/api/v3/calendar-apple/disconnect', {}, this.calFeedHeaders());
                                this.appleConnected = false;
                                this.appleAppleId = '';
                            } catch (e2) {
                                console.log('rotateFeed apple disconnect error:', e2);
                            }
                        }
                        this.$notify({ title: 'Calendar reset', message: 'A new calendar link was generated and the old access was revoked.', type: 'success' });
                    } catch (err) {
                        console.log('rotateFeed error:', err);
                        this.$notify.error({ title: 'Error', message: 'Could not reset your calendar access.' });
                    } finally {
                        this.calRotating = false;
                    }
                }).catch(() => { /* user cancelled */ });
            },
            // #1609 — refresh the welcome VEVENT so a fresh client pull proves the subscription.
            async sendTestEvent() {
                this.calTesting = true;
                try {
                    const res = await service.postUrl('/api/v3/calendar-feed/test', {}, this.calFeedHeaders());
                    const message = (res && res.data && res.data.result && res.data.result.message)
                        ? res.data.result.message
                        : 'Test event sent. Apple usually refreshes within minutes; Google can take a few hours.';
                    this.$notify({ title: 'Test event sent', message, type: 'success', duration: 8000 });
                } catch (err) {
                    console.log('sendTestEvent error:', err);
                    this.$notify.error({ title: 'Error', message: 'Could not send the test event.' });
                } finally {
                    this.calTesting = false;
                }
            },
            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },
            async changeMailingAction() {
                let result = this.mailing_action ? 'subscribe' : 'unsubscribe';
                console.log(this.mailing_action, result);
                await service.put('employee/'+ this.userID + '/updateMailingList',{
                    mailing_action: result
                }, {
                    'Authorization': this.userToken
                }).then((res) => {
                    if(res.data) {
                        console.log(res.data);
                        this.$notify.success(
                            {
                                message: res.data.status_message,
                                title: 'Success'
                            }
                        );
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$notify(
                        {
                            type: 'error',
                            message: 'Something went wrong',
                            title: 'Error'
                        }
                    );

                });
            },
            refreshSubscription() {
                // console.log("Refresh Nylas Subscription");
                this.$notify({
                    type: 'success',
                    title: this.$t('success'),
                    message: 'Nylas Integration Refreshed'
                });
            },

            tokenCreated(token) {
                setTimeout(()=>{
                    // self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                    console.log("Token Created ....................",token);
                },1000)

            },

            async submit () {
                // if(this.employeeEmail=='' || this.errors.has('email')) {
                //     this.$notify.error({
                //         message: "Valid Email is required to proceed",
                //         title: "Required"
                //     });
                //     return;
                // }
                // this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                // console.log(this.getNylasUserEmail);
                if(this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                }
            },

            async handleCheckout() {
                this.loading = true;
                if(this.employeeEmail=='' || this.errors.has('email')) {
                    this.$notify.error({
                        message: "Valid Email is required to proceed",
                        title: "Required"
                    });
                    return;
                }
                this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                console.log(this.employeeData);
                if(this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                }else {
                    try {
                        let headers = {
                            // 'authorization': this.userToken
                        }
                        let body = {
                            // userId: this.userID, // Pass user-related data here
                            line_items: {
                                price: 'price_1Kb4d6JTPH63iEDVOv4sJ7jk', // The id of the recurring price you created in your Stripe dashboard
                                quantity: 1
                            },
                            success_url: this.successURL,
                            cancel_url: this.cancelURL,
                            customer_id: this.stripe_customer_id,
                            client_reference_id: this.userID,
                            allow_promotion_codes: "true"
                        }
                        console.log("Body: ......................", body);
                        const response = await service.post('employee/create-stripe-session', body, headers );
                        // console.log("Session ID: ......................", response.data);
                        const { sessionId } = response.data;
                        const { error } = await this.stripe.redirectToCheckout({ sessionId });
                        if (error) console.error('Stripe Checkout Error:', error);
                    } catch (error) {
                        console.error("Error during checkout:", error);
                    } finally {
                        this.loading = false;
                    }
                }
            },


            async cancelSubscription() {
                this.$confirm('Are you sure you would like to cancel the Subscription? ', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                }).then(async() => {
                    // Cancel Stripe Subscription
                    await this.cancelStripeSubscription();

                    // Cancel Nylas Subscription
                    await this.cancelNylasSubscription();


                }).catch((error) => {
                    console.log(error);
                    this.getEmpDetails();
                });
            },

            async cancelNylasSubscription() {
                await service.post('employee/cancelNylasSubscription',{
                user_id: this.userID
                }, {
                    'Authorization': this.userToken
                }).then(async(res) => {
                    // console.log(res.data);
                    // this.getEmpDetails();
                    if(res.data) {
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: res.data.status_message
                        });
                    }
                    await this.getEmpDetails();
                    this.dataAvailable = true;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async cancelStripeSubscription() {
                this.dataAvailable = false;
                    await service.post('employee/cancelStripeSubscription',{
                    user_id: this.userID
                    }, {
                        'Authorization': this.userToken
                    }).then((res) => {
                        // console.log(res.data);
                        // this.getEmpDetails();
                        if(res.data) {
                            this.$notify({
                                type: 'success',
                                title: this.$t('success'),
                                message: res.data.status_message
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            async generateNylasLink() {
                await service.get('employee/authorizeNylas', {
                    'Authorization': this.userToken,
                    'user-id': this.userID,
                    'email': this.getNylasUserEmail
                }).then((res) => {
                    if(res.data&&res.data.result) {
                        window.location.href = res.data.result;
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: 'Nylas Subscription Started. Thank you for being with us!'
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },

            getLogsAccess(){
                if(this.able_to_access_logs || this.userRoleSlug != 'employee'){
                    return true;
                }
                return false;
            },

            isCallstewardUK(){
                return dateTimeConvert.isCallstewardUK();
            },

            notifyStartStop(){
                var formData ={
                    'employee_id': this.employeeData.id,
                    'status': this.notifyLock
                };
                // console.log(formData);

                service.post('employee/stopNotificationSettings', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: 'Success.'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },

            notifyHistory(){
                this.$store.dispatch('setNotificationType', 'employeeHistoryAction');
                this.$router.push({
                    path: `/notifyLog/`+ btoa(this.employeeData.id)
                });
            },

            dateSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'date',
                    'format_string': this.employeeData.date_format
                }
                this.exampleDate = moment(Date.now()).format(this.employeeData.date_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,

                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("date_format", this.employeeData.date_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });

            },

            generateLink(){
                service.get('call/calendar/'+this.employeeData.id, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res.data.result.calendar_file);
                    this.ics_link=res.data.result.calendar_file;

                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: 'File not found. '
                    });
                });
            },

            timeSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'time',
                    'format_string': this.employeeData.time_format
                }
                this.exampleTime = moment(Date.now()).format(this.employeeData.time_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("time_format", this.employeeData.time_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });
            },

            changeNotificationSettings(){
                // console.log(this.pickedNotify);
                // if(this.pickedNotify=='email'){
                //     this.emailNotificationSettings();
                // }else{
                //     this.smsNotificationSettings();
                // }
                this.emailNotificationSettings();
                this.smsNotificationSettings();
                this.changeAppNotification();
                this.$store.dispatch('setNotificationType', this.pickedNotify);
            },

            changeNotifyToApp() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyApp = 1
                    return;
                }

                // When toggling ON, show pre-prompt if browser permission not yet decided
                if (this.notifyApp == 1 && this.browserPushState === 'default') {
                    this.showPushPrompt = true;
                }

                {
                    var formData = {
                        'status': this.notifyApp,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/appNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            acceptPushPrompt() {
                this.showPushPrompt = false;
                var self = this;
                requestNotificationPermission(this.userToken, this.userClientID)
                    .then(function () {
                        self.browserPushState = getNotificationPermissionState();
                        if (self.browserPushState === 'granted') {
                            self.$notify.success({
                                message: 'Browser notifications enabled',
                                title: self.$t('success')
                            });
                        }
                    });
            },
            declinePushPrompt() {
                this.showPushPrompt = false;
            },
            // emailNotificationSettings() {
            changeNotifyToEmail() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyEmail = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyEmail,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/emailNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                        //bus.$emit('onUpdateOrAdd', 'On update notifications settings');
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // smsNotificationSettings() {
            changeNotifyToSms() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifySms = 1
                    return;
                } else {
                    // console.log("Sms Notify Else")
                    var formData = {
                        'status': this.notifySms,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/smsNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            changeSignInOptions2fa() {
                this.two_factor_auth = !this.two_factor_auth;

                var formData = {
                    'status': this.two_factor_auth ? 1 : 0,
                    'user_id': this.employeeData.employable.id
                };

                service.post('employee/twoFactorAuthSettings', formData, {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Login Option Updated',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message: 'Something went Wrong',
                        type: 'error'
                    });
                    console.log(err);
                });
            },

            changeSignInOptionsFpa() {
                this.finger_print_auth = !this.finger_print_auth;
                // var formData = {
                //     'status': this.finger_print_auth ? 1 : 0,
                //     'user_id': this.employeeData.employable.id
                // };
                // console.log(formData);
            },

            async getEmpDetails() {
                // this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                await service.get('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        //this.employeeData = basic.data.result;
                        this.employeeData = res.data.result;
                        console.log("Employee: ....................",this.employeeData);
                        this.nylas_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.nylas_subscription?this.employeeData.employable.nylas_subscription:null;
                        this.stripe_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription?this.employeeData.employable.stripe_subscription:null;

                        this.is_nylas_subscription_active=this.nylas_subscription?this.nylas_subscription.is_active:false;

                        this.employeeEmail = this.nylas_subscription && this.nylas_subscription.email_address ? this.nylas_subscription.email_address:'';

                        this.dataAvailable = true;
                        this.$forceUpdate();
                        // this.userImage = this.detailEmployee.employable;
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            getMailingListStatus() {
                service.get('employee/'+ this.userID +'/checkUserSubscriptionStatus', {
                    'Authorization': this.userToken,
                })
                .then((res) => {
                    this.mailing_action=res.data;
                    console.log(res.data);
                    // this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getClientData() {
                var clientId = this.userClientID;
                if (!clientId && this.employeeData && this.employeeData.client_employee && this.employeeData.client_employee.client_id) {
                    clientId = this.employeeData.client_employee.client_id;
                }
                if (!clientId) {
                    console.warn('getClientData: no clientId available');
                    return;
                }
                await service.get('client/' + clientId, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.mailing_list_visibility_flag = this.clientData.mailing_list_visibility_flag;
                }).catch((err) => {
                    console.log('getClientData error:', err);
                });
            },
        },

        async created() {
            // Load employee data and client data in parallel. #2066 removed a third
            // element here that loaded Stripe.js on every visit to this page.
            var [empResult] = await Promise.all([
                this.getEmpDetails(),
                this.getClientData()
            ]);
            this.stripe_customer_id = this.employeeData && this.employeeData.employable && this.employeeData.employable.stripe_customer_id ? this.employeeData.employable.stripe_customer_id : null;
            console.log("Stripe Customer Id ..............................",this.stripe_customer_id);
            this.able_to_access_logs = this.employeeData.employee_status.able_to_access_logs;
            this.notifyApp = this.employeeData.app_notification
            this.notifyEmail = this.employeeData.email_notification
            this.notifySms = this.employeeData.sms_notification
            this.two_factor_auth = this.employeeData.employable.two_factor_auth ? true : false;
            this.notifyLock=(this.employeeData.stop_notification==0)?false:true;
            this.getMailingListStatus();
            this.loadCalendarFeed(); // #1548 provision + fetch the user's .ics subscription link
            this.loadGoogleStatus(); // #1519 reflect Google connect state (connect vs disconnect button)
            this.loadAppleStatus(); // #1519 reflect Apple CalDAV connect state (connect vs disconnect button)
            this.loadCarpool(); // #1720 P2 carpool opt-in + pickup profile
        }
    }

</script>
<style scoped>
.notify-icon {
    margin:10px 10px 10px 0;
}
.nylas-logo {
    height: 25px;
    width: 60px;
    padding: 8px 5px 0;
}
.nylas-event {
    font-size: 16px;
    border-radius: 5px;
    text-decoration: none!important;
    padding: 12px 10px 5px;
    /* color: #8158b8!important;
    border: 1px solid #8158b8; */
}
.nylas-event.active {
    background-color: #8158b8!important;
    border: 1px solid #8158b8;
}
.nylas-event.active:hover {
    color: #8158b8!important;
    border: 1px solid #8158b8;
}

.user-spec {
    font-size: 14px;
    /* color: #3a89ce; */
    margin: 0;
    padding: 0;
}
.nylas-subscribe-button {
    margin: 15px 10px 10px 0;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #258325;
    color: #ffffff;
    font-size:13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-cancel-block {
    /* margin: 15px 10px 10px 0; */
    display: flex;
    align-items: flex-start;
    flex-direction: row;
}
.nylas-subscription-label{
    padding: 6px 5px 10px 20px;
    margin-top: 10px;
    /* margin-bottom: 10px; */
    border: none;
    outline: none;
    background-color: #ffffff;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
}
.nylas-cancel-button {
    padding: 10px 20px;
    margin: 10px;
    border: none;
    outline: none;
    background-color: #e7eee7;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-refresh-button {
    /* margin: 15px 10px 10px 0; */
    margin: 10px;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #FB9803;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}

/* #1548 Calendar Subscription panel */
.o-cal-feed-loading {
    padding: 12px 0;
    color: #606266;
}
.o-cal-feed-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 6px 0 12px;
}
.o-cal-feed-url {
    flex: 1 1 auto;
    min-width: 0;
    font-family: monospace;
    font-size: 12px;
    background-color: #f5f7fa;
    cursor: text;
}
.o-cal-feed-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
}
.o-cal-link-btn {
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}
.o-cal-link-btn.is-disabled {
    pointer-events: none;
    opacity: 0.6;
}
.o-cal-feed-help {
    color: #909399;
    font-size: 12px;
}
/* #1572 Apple subscribe QR */
.o-cal-apple-qr {
    margin: 10px 0;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
    display: inline-block;
}
.o-cal-qr {
    width: 220px;
    max-width: 100%;
    margin: 6px 0;
}
.o-cal-qr svg { display: block; width: 100%; height: auto; }

/* #1644 Calendar Sync — 4 titled protocol boxes (layout reorg) */
.o-cs-header { margin: 0 0 2px; }
.o-cs-subtitle { color: #5c6b7a; font-size: 13px; margin: 2px 0 16px; }
.o-cs-card {
    background: #fff;
    border: 1px solid #e2e8ee;
    border-radius: 12px;
    padding: 16px 16px 14px;
    margin-bottom: 12px;
}
.o-cs-card--caution { border-color: #f0d9a8; background: #fffdf7; }
.o-cs-row1 { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; margin-bottom: 6px; }
.o-cs-num {
    width: 22px; height: 22px; border-radius: 7px;
    background: #eef2f6; color: #5c6b7a;
    font-size: 12px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; flex: 0 0 auto;
}
.o-cs-title { font-size: 15px; font-weight: 600; margin: 0; color: #1c2530; }
.o-cs-badge {
    font-size: 11px; font-weight: 600; padding: 3px 9px;
    border-radius: 999px; white-space: nowrap; letter-spacing: .02em;
}
.o-cs-badge--base { background: #eef2f6; color: #5c6b7a; }
.o-cs-badge--good { background: #e4f5ec; color: #1a7f4b; }
.o-cs-badge--beta { background: #fbf1d9; color: #9a6a00; }
.o-cs-badge--ro   { background: #eaf1ff; color: #2f6df6; }
.o-cs-exp { font-size: 13px; color: #5c6b7a; margin: 0 0 12px; padding-left: 31px; }
.o-cs-exp b { color: #1c2530; font-weight: 600; }
.o-cs-ctrls { padding-left: 31px; }
.o-cs-btns { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-top: 8px; }
.o-cs-note { font-size: 11.5px; color: #909399; margin: 6px 0 0; }
.o-cs-connected { font-size: 13px; color: #1c2530; margin: 0; }
.o-cs-connected .fa-check { color: #3c763d; }
.o-cs-warnbox {
    display: flex; gap: 9px; align-items: flex-start;
    background: #fbf1d9; border: 1px solid #f0d9a8; border-radius: 8px;
    padding: 9px 11px; font-size: 12.5px; color: #1c2530; margin-bottom: 4px;
}
.o-cs-warnbox .fa { color: #9a6a00; margin-top: 2px; flex: 0 0 auto; }
.o-cs-field-row { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.o-cs-field-row .el-input { flex: 1 1 220px; }
.o-cs-qrline { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
.o-cs-qr-actions { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
/* danger/subtle text buttons (Reset, Disconnect) — beat Element's --text blue */
.o-cs-danger.el-button { color: #c0392b; }
.o-cs-danger.el-button:hover, .o-cs-danger.el-button:focus { color: #e05c4a; }
@media (max-width: 640px) {
    .o-cs-exp, .o-cs-ctrls { padding-left: 0; }
}
/* #1720 Carpool card */
.o-carpool-optin { display: flex; align-items: center; gap: 8px; cursor: pointer; font-weight: 600; margin: 0; }
.o-carpool-optin input[type="checkbox"] { width: auto; margin: 0; flex: 0 0 auto; }
.o-carpool-pickup { margin-top: 10px; }
.o-carpool-pickup .h6 { margin-bottom: 6px; }
.o-carpool-radio { display: flex; align-items: center; gap: 8px; cursor: pointer; margin: 6px 0; font-weight: 400; }
.o-carpool-radio input[type="radio"] { width: auto; margin: 0; flex: 0 0 auto; }
.o-carpool-warn { font-size: 12px; color: #9a6a00; margin: 4px 0 4px 22px; }
.o-carpool-custom { margin: 8px 0 8px 22px; display: flex; flex-direction: column; gap: 8px; align-items: flex-start; }
.o-carpool-custom .form-control { max-width: 320px; }
.o-carpool-coords { font-size: 12px; color: #6b7280; margin: 0; }
.o-carpool-save { margin-top: 10px; }
.o-carpool-for { font-size: 13px; margin-bottom: 8px; }
.o-carpool-matches { list-style: none; padding: 0; margin: 0; }
.o-carpool-match { display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px solid #eef0f3; }
.o-carpool-match-name { flex: 1 1 auto; font-weight: 600; }
.o-carpool-match-dist { color: #6b7280; font-size: 12px; }
.o-carpool-match-phone { font-size: 13px; white-space: nowrap; }
.o-carpool-empty, .o-carpool-note { font-size: 12px; color: #909399; }
.o-carpool-pin-modal { padding: 14px; }
.o-carpool-pin-actions { display: flex; gap: 8px; justify-content: center; margin-top: 12px; flex-wrap: wrap; }
.o-muted { color: #b0b3b8; }
.o-carpool-sep { margin: 28px 0 6px; border-top: 1px solid #e6e9ee; }
</style>
